import moment from "moment";

export const DEFAULT_APPOINTMENT_INTERVAL_MINUTES = 10;

export function resolveAppointmentInterval(minutes: unknown): number {
  const parsed = Number(minutes);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return DEFAULT_APPOINTMENT_INTERVAL_MINUTES;
  }
  return parsed;
}

export function generateAppointmentSlots(
  startHhMm: string,
  endHhMm: string,
  intervalMinutes: unknown,
  options?: {
    selectedDate?: string;
    now?: moment.Moment;
  }
): string[] {
  const interval = resolveAppointmentInterval(intervalMinutes);
  const horaInicio = moment(startHhMm, "HH:mm");
  const horaFin = moment(endHhMm, "HH:mm");
  const diff = horaFin.diff(horaInicio, "minutes");
  const slots: string[] = [];
  const now = options?.now ?? moment();
  const currentDate = now.format("YYYY-MM-DD");
  const selectedDate = options?.selectedDate;

  for (let i = 0; i <= diff; i += interval) {
    const hora = horaInicio.clone().add(i, "minutes");
    if (!selectedDate || selectedDate !== currentDate || hora.isAfter(now)) {
      slots.push(hora.format("HH:mm"));
    }
  }

  return slots;
}
